export enum BraceStyle {
  Straight = 'straight',
  ArchedBottom = 'arched-bottom',
}
